import { DEVICE_HUB_EVENT } from "@/constants/apis";
import deviceHubObserver from "@/observers/deviceHubObserver";
// eslint-disable-next-line import/no-cycle
import {
  removeEventListener,
  subscribeEventListener,
} from "@/websocket/signalRManager";

const silentEvent = [];

export const eventHandlers = {
  [DEVICE_HUB_EVENT.OnStateChange]: deviceHubObserver.notify.onStateChange,
  [DEVICE_HUB_EVENT.ManualProfileUpdated]:
    deviceHubObserver.notify.manualProfileUpdated,
  [DEVICE_HUB_EVENT.CleaningProfileUpdated]:
    deviceHubObserver.notify.cleaningProfileUpdated,
  [DEVICE_HUB_EVENT.OnDeviceFailure]: deviceHubObserver.notify.onDeviceFailure,
  [DEVICE_HUB_EVENT.OnRecoveryStatusUpdated]:
    deviceHubObserver.notify.onRecoveryStatusUpdated,
  [DEVICE_HUB_EVENT.OnAutoProfileUpdated]:
    deviceHubObserver.notify.onAutoProfileUpdated,
  [DEVICE_HUB_EVENT.OnCycleTimesUpdated]:
    deviceHubObserver.notify.onCycleTimesUpdated,
  [DEVICE_HUB_EVENT.OnManualControlStatusUpdated]:
    deviceHubObserver.notify.onManualControlStatusUpdated,
  [DEVICE_HUB_EVENT.OnDiafiltrationStatusUpdated]:
    deviceHubObserver.notify.onDiafiltrationStatusUpdated,
  [DEVICE_HUB_EVENT.OnVolumeThresholdError]:
    deviceHubObserver.notify.onVolumeThresholdError,
  [DEVICE_HUB_EVENT.OnLicenseExpired]:
    deviceHubObserver.notify.onLicenseExpired,
  [DEVICE_HUB_EVENT.OnDelayProfilePreparation]:
    deviceHubObserver.notify.onDelayProfilePreparation,
  [DEVICE_HUB_EVENT.OnDelayProfileStart]:
    deviceHubObserver.notify.onDelayProfileStart,
  [DEVICE_HUB_EVENT.OnDeviceLockUpdated]:
    deviceHubObserver.notify.onDeviceLockUpdated,
};

export const subscribeEvent = (hubName, eventType) =>
  subscribeEventListener(
    hubName,
    eventType,
    eventHandlers[eventType],
    silentEvent.includes(eventType)
  );

export const removeEvent = (hubName, eventType) =>
  removeEventListener(hubName, eventType);

const subscribeEvents = (hubName) =>
  Object.keys(eventHandlers).forEach((eventType) =>
    subscribeEvent(hubName, eventType)
  );

export default subscribeEvents;
